import React from 'react';
import {
  Action,
  Actions,
  FileDownloadIcon,
  FileUploadIcon,
  DescriptionIcon,
  MoreVertIcon,
  ActionBar,
} from '@gogame/components';
import { useChooseFiles } from '@gogame/hooks-ts';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField, useScreenState, useScreenTitle } from '@gogame/screens';
import {
  useExportInfluencerChannel,
  useUploadInfluencerChannel,
} from 'scenes/Influencers/InfluencersChannels/data';
import { useExportTemplate, useStatusTemplates } from 'Templates';
import { TEMPLATE_NEW_INFLUENCER_CHANNEL } from 'scenes/Influencers/InfluencersChannels/constants';

export default ({
  onCreate: handleCreate,
  onOpenInfluencers: handleOpenInfluencers,
  onOpenCategories: handleOpenCategories,
}) => {
  const [screenTitle] = useScreenTitle();
  const screenState = useScreenState();
  const [exportInfluencerChannel] = useExportInfluencerChannel();
  const [uploadInfluencerChannel] = useUploadInfluencerChannel();
  const [exportInfluencerChannelTemplate] = useExportTemplate({
    name: TEMPLATE_NEW_INFLUENCER_CHANNEL,
  });

  const templateUpdated = useStatusTemplates({
    name: TEMPLATE_NEW_INFLUENCER_CHANNEL,
  });
  const chooseSpreadsheet = useChooseFiles({
    multiple: false,
    accept: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
  });

  const handleExportInfluencerChannel = async () => {
    await exportInfluencerChannel({
      filters: screenState.filters,
      tableSettings: screenState.tableSettings,
      searchQuery: screenState.searchQuery,
    });
  };
  const handleUploadInfluencerChannel = async () => {
    const file = await chooseSpreadsheet();
    await uploadInfluencerChannel(file);
  };

  const handleExportTemplate = () => {
    exportInfluencerChannelTemplate();
  };

  return (
    <>
      <ActionBar
        title={screenTitle}
        search={<SearchField tooltip={'Search by name or id'} />}
        secondaryActions={
          <Actions>
            <Action
              icon={<FileDownloadIcon />}
              onClick={handleExportInfluencerChannel}
              label={'Export Influencer Channels'}
            />
            <Action
              label={'Import Influencer Channels'}
              icon={<FileUploadIcon />}
              onClick={handleUploadInfluencerChannel}
            />
            <Action
              label={`Download template${templateUpdated ? ' (Updated)' : ''}`}
              icon={<DescriptionIcon />}
              onClick={handleExportTemplate}
              badge={templateUpdated}
            />
            <Action component={FullScreenToggler} />
            <Action icon={<MoreVertIcon />} tooltip={'More'}>
              <Action
                label={'Manage Influencers'}
                onClick={handleOpenInfluencers}
              />
              <Action
                label={'Manage Categories'}
                onClick={handleOpenCategories}
              />
            </Action>
          </Actions>
        }
        primaryActions={
          <Actions>
            <Action
              border={true}
              button={true}
              add={true}
              iconContent={true}
              tooltip={'Add Influencer Channel'}
              variant={'outlined'}
              onClick={handleCreate}
            />
          </Actions>
        }
      />
    </>
  );
};
